import { render, staticRenderFns } from "./storage_details.vue?vue&type=template&id=61d19a9a&scoped=true&"
import script from "./storage_details.vue?vue&type=script&lang=js&"
export * from "./storage_details.vue?vue&type=script&lang=js&"
import style0 from "./storage_details.vue?vue&type=style&index=0&id=61d19a9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d19a9a",
  null
  
)

export default component.exports